import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@chakra-ui/react';

// Small On/Off pill used to render a boolean regional-deduction default in the
// Regional Settings list and detail views.
const OnOffBadge = ({ value }) => (
  <Badge
    colorScheme={value ? 'green' : 'gray'}
    variant="subtle"
    borderRadius="full"
    px={2.5}
    py={0.5}
    fontSize="xs"
    fontWeight="600"
    textTransform="none"
  >
    {value ? 'On' : 'Off'}
  </Badge>
);

OnOffBadge.propTypes = {
  value: PropTypes.bool,
};

export default OnOffBadge;
